
import Button from '../../../components/base/Button';

export default function WhyPresetSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            なぜ、今"プリセット"が利益に直結するのか
          </h2>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-time-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              試し削りは"コスト"
            </h3>
            <p className="text-gray-600 leading-relaxed">
              機械停止×オペレーター拘束＝売上機会の放棄。試し削りの時間は純粋な損失時間です。
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-focus-3-line text-2xl text-yellow-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              数µmの世界
            </h3>
            <p className="text-gray-600 leading-relaxed">
              仕上げボーリングは数µmの世界。勘と経験だけでは再現困難。測って合わせる体制が最短。
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-team-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              人材多様化対応
            </h3>
            <p className="text-gray-600 leading-relaxed">
              誰でも同じ品質を出せる仕組み＝標準化が競争力。属人化からの脱却が必須。
            </p>
          </div>
        </div>
        
        <div className="bg-yellow-400 p-8 rounded-xl text-center">
          <h3 className="text-2xl font-bold text-black mb-4">
            結論：ツールプリセッターは"単なる工具長計測器"ではない
          </h3>
          <p className="text-2xl font-bold text-black mb-6">
            段取りと品質を同時に最短化する利益創出装置です
          </p>
          <Button variant="secondary" size="lg" onClick={scrollToContact}>
            <i className="ri-calculator-line mr-2"></i>
            ROI診断を申し込む
          </Button>
        </div>
      </div>
    </section>
  );
}
